
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_164jl_1ns0c_5"
};
  